import { Table, Row } from 'antd'
import usePagination from 'helper/usePagination'
import { Menu, Space } from 'antd'
import Item from 'antd/lib/list/Item'
import { Tag } from 'antd'
import editblackPencil from 'assets/Images/editblackPencil.svg'
import deleteBlackIcon from 'assets/Images/deleteBlackIcon.svg'

const InventoryTable = ({
  data,
  params,
  setParams,
  hidCols,
  setSelectedRows,
}: any) => {
  const [paginationInfo, onTableChange] = usePagination({
    totalCount: data?.count || 0,
    currentPage: params.page,
    setParams,
  })
  const rowSelection = {
    onChange: (selectedRowKeys: React.Key[], selectedRows: any[]) => {
      setSelectedRows(selectedRows)
    },
    getCheckboxProps: (record: any) => ({
      name: record.name,
    }),
  }

  const columnss = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      render: (text: any, record: any) => (
        <div style={{ cursor: 'pointer' }} className="py-10px">
          <Space size={8}>{record.name}</Space>
        </div>
      ),

      className: hidCols.name === false ? 'display-none' : '',
    },
    {
      title: 'Organization',
      dataIndex: 'organization',
      key: 'organization',
      render: (text: any, record: any) => (
        <div style={{ cursor: 'pointer' }}>
          <Space size={8}>{record.organization.name}</Space>
        </div>
      ),

      className: hidCols.organization === false ? 'display-none' : '',
    },
    {
      title: 'Storage locations',
      dataIndex: 'Storage',
      key: 'Storage',
      render: (text, record) => {
        const firstLocation = record.storeLocations[0]
        if (firstLocation) {
          return (
            <div style={{ cursor: 'pointer' }}>
              <Space size={8}>
                {`${firstLocation.title}, ${firstLocation.street}, ${firstLocation.city}`}
              </Space>
            </div>
          )
        } else {
          return ''
        }
      },
      className: hidCols.location === false ? 'display-none' : '',
    },
    {
      title: 'Quantity, unit',
      dataIndex: 'Quantity',
      key: 'Quantity',
      render: (text, record) => {
        if (
          record.totalQuantity !== undefined &&
          record.storageLocations.length > 0
        ) {
          return (
            <div style={{ cursor: 'pointer' }}>
              <Space size={8}>
                {record.totalQuantity},{' '}
                {record.storageLocations[0].quantity.unit}
              </Space>
            </div>
          )
        } else {
          return ''
        }
      },
      className: hidCols.Quantity === false ? 'display-none' : '',
    },

    {
      title: 'Price, USD',
      dataIndex: 'Price',
      key: 'Price',
      render: (text, record) => {
        let displayPrice

        if (record.price !== undefined) {
          displayPrice = record.price
        } else if (
          record.priceRange &&
          record.priceRange.min !== undefined &&
          record.priceRange.max !== undefined
        ) {
          displayPrice = `${record.priceRange.min} - ${record.priceRange.max}`
        } else {
          displayPrice = ''
        }

        return (
          <div style={{ cursor: 'pointer' }}>
            <Space size={8}>{displayPrice}</Space>
          </div>
        )
      },

      className: hidCols.Price === false ? 'display-none' : '',
    },
    {
      title: 'Actions',
      dataIndex: 'action',
      key: 'action',
      width: 120,
      render: (text: any, record: any) => (
        <div style={{ cursor: 'pointer' }} className="py-10px">
          <Space className="orgn-action-btn">
            <img
              src={editblackPencil}
              alt="edit"
              width={20}
              className="cursor_pointer"
            />
            <img
              src={deleteBlackIcon}
              alt="delete"
              className="cursor_pointer"
            />
          </Space>
        </div>
      ),

      className: hidCols.action === false ? 'display-none' : '',
    },
  ]
  return (
    <div className="mt-20">
      <Row align="middle">
        <Table
          className="organizations_table"
          style={{ width: '100%' }}
          dataSource={data?.records}
          rowSelection={rowSelection}
          columns={columnss}
          scroll={{ x: 400 }}
          pagination={paginationInfo}
          onChange={onTableChange}
        />
      </Row>
    </div>
  )
}
export default InventoryTable
